import { FC, useContext,memo, useState } from "react";
import { Link } from "react-router-dom";

import { AuthContext } from "src/context/authContext";

import { TreatableProps } from "src/pages/actionDashboard/types";
import { getDateFormat } from "src/helpers/dateTime";
import AddNote from "src/components/modals/addNote";
import ManufacturerNextStepActions from "../manufactureNextStepActions";



type ModalState<T = any> = {
  isModalVisible: boolean;
} & T;


const CoverageAvailableTableRow: FC<{ treatable: TreatableProps; refreshListing: () => void; }> = ({ treatable, refreshListing }): JSX.Element => {

  const { isManufacturer } = useContext(AuthContext);
  const [saveNoteModal, setSaveNoteModal] = useState<ModalState<{ caseId: number }>>({ isModalVisible: false, caseId: 0 });


  return (
    <>
     <tr>
      {treatable.patient_name !== 'Redacted' ?
        <td className="text-center align-middle">
          <Link 
            to={`/global_patients/${treatable.patient_id}`}
            
          >
            {treatable.patient_name}
          </Link>
        </td>
        :
        <td className="text-center align-middle">{treatable.patient_name}</td>
      }
      <td className="text-center align-middle">
        <Link 
          to={`/global_patients/${treatable.patient_id}`}
          className={`${treatable.drug_name === "iovera°" ? 'text-iovera' : 'text-zilretta'} `}
        >
          {treatable.patient_id}
        </Link>
      </td>
      <td className="text-center align-middle">
        <Link 
          to={`/cases/detail/${treatable.bi_case_id}`}
          className={`${treatable.drug_name === "iovera°" ? 'text-iovera' : 'text-zilretta'} `}
        >
          {treatable.bi_case_id}
        </Link>
      </td>
      <td className="text-center align-middle">
        {treatable.drug_name}
      </td>
      <td className="text-center align-middle">
        {isManufacturer ? getDateFormat(treatable.bi_completed) : treatable.bi_completed}
      </td>
      <td className="text-center align-middle">
        {treatable.payer}
      </td>
      <td className="text-center align-middle">{treatable.physician}</td>
      <td className="align-middle">
        <span className={`badge ${treatable.medical_coverage_status_color !== 5 ? "" : ""} background-color-${treatable.medical_coverage_status_color}`}>
            {treatable.medical_coverage_status}
        </span>
      </td>
      <td className="align-middle">
          <span className={`badge ${treatable.pharmacy_coverage_status_color !== 5 ? "" : ""} background-color-${treatable.pharmacy_coverage_status_color}`}>
              {treatable.pharmacy_coverage_status}
          </span>
      </td>
      {/* <td className="align-middle">
          {treatable.copay_status}
      </td> */}
      <td className={`text-center align-middle`}>
        <ManufacturerNextStepActions refreshListing={refreshListing} kase={treatable} next_steps={treatable.next_steps} />
      </td>
      <td className="text-center align-middle" style={{ minWidth: 70 }}>
        <button
          className="btn btn-success btn-sm m-1 text-nowrap"
        onClick={() =>
          setSaveNoteModal({ isModalVisible: true, caseId: treatable.bi_case_id })
        }
        >
          {'Add Note'}
        </button>
          {saveNoteModal.isModalVisible && (
              <AddNote
                  {...saveNoteModal}
                  hideModal={() => setSaveNoteModal({ isModalVisible: false, caseId: 0 })}
                  refreshListing={refreshListing}
              />
          )}
      </td>
    </tr>
    </>
  )
}

export default memo(CoverageAvailableTableRow);
